import { action } from 'satcheljs';

export const fetchPublisherEvaluationStatusAction = action('fetchPublisherEvaluationStatusAction', ({ cache = true } = {}) => ({ cache }));
